export enum MoveDirectionEnum {
  UP ,
  DOWN ,
}
